import type { GlobalSearchResponse } from './global-search-models'

export const GLOBAL_SEARCH_MOCK_RESPONSE = {
  nextPageMarker: 5,
  total: { value: 67, relation: 'Eq' },
  items: [
    {
      application: 'contact',
      id: '90132',
      score: 1,
      data: {
        userKey: 'result1',
        firstName: 'Kermit',
        lastName: 'TheFrog',
        keywords: '456',
        phone: '123-456-7890',
        email: '',
      },
    },
    {
      application: 'contact',
      id: '91343',
      score: 1,
      data: {
        userKey: 'result2',
        firstName: 'Miss',
        lastName: 'Piggy',
        keywords: '456',
        phone: '123-456-7890',
        email: '',
      },
    },
    {
      application: 'contact',
      id: '94137',
      score: 1,
      data: {
        userKey: 'result1',
        firstName: 'Fozzie',
        lastName: 'Bear',
        keywords: '456',
        phone: '123-456-7890',
        email: 'really456incrediblyextremelylongemailaddress@superlongemailaddressdomainnamewebsite.com',
      },
    },
    {
      application: 'contact',
      id: '96771',
      score: 1,
      data: {
        userKey: '3838948547100956682',
        firstName: 'Elisa',
        lastName: 'Matteo',
        keywords: '@shell',
        phone: '555-Elisa',
        email: 'elisa@goto.com',
      },
    },
    {
      application: 'contact',
      id: '66381',
      score: 1,
      data: {
        userKey: '4547668473900510970',
        firstName: 'Vincent',
        lastName: 'Audy',
        keywords: '@shell',
        phone: '555-Vincent',
        email: 'vincent@goto.com',
      },
    },
    {
      application: 'contact',
      id: '37227',
      score: 1,
      data: {
        userKey: '158619268522209074',
        firstName: 'Elise',
        lastName: 'Pelchat',
        keywords: '@shell',
        phone: '555-Elise',
        email: 'elise@goto.com',
      },
    },
    {
      application: 'contact',
      id: '26433',
      score: 1,
      data: {
        userKey: '602681216181426860',
        firstName: 'Marie',
        lastName: 'Foxall',
        keywords: '@shell',
        phone: '555-Marie',
        email: 'marie@goto.com',
      },
    },
    {
      application: 'contact',
      id: '75936',
      score: 1,
      data: {
        userKey: '6146506820683186259',
        firstName: 'Brian',
        lastName: 'Motherway',
        keywords: '@shell',
        phone: '555-Brian',
        email: 'brian@goto.com',
      },
    },
    {
      application: 'contact',
      id: '26541',
      score: 1,
      data: {
        userKey: '6300506601969632429',
        firstName: 'Daniel',
        lastName: 'Bart',
        keywords: '@shell',
        phone: '555-Daniel',
        email: 'daniel@goto.com',
      },
    },
    {
      application: 'contact',
      id: '60757',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'Jose',
        lastName: 'Gomez',
        keywords: '@shell',
        phone: '555-Jose',
        email: 'jose@goto.com',
      },
    },
    {
      application: 'contact',
      id: '48485',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Entry',
        keywords: '@shell',
        phone: '555-Jose',
        email: 'jose@goto.com',
      },
    },
    {
      application: 'contact',
      id: '82933',
      score: 1,
      data: {
        email: 'jose@goto.com',
        firstName: 'New',
        keywords: '@shell',
        lastName: 'Test',
        phone: '555-Jose',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '86369',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 1',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '90126',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 2',
        phone: '555-test',
        userKey: '3838948547100956682',
      },
    },
    {
      application: 'contact',
      id: '36809',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 3',
        phone: '555-test',
        userKey: '4547668473900510970',
      },
    },
    {
      application: 'contact',
      id: '81203',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 4',
        phone: '555-test',
        userKey: '158619268522209074',
      },
    },
    {
      application: 'contact',
      id: '38627',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 5',
        phone: '555-test',
        userKey: '602681216181426860',
      },
    },
    {
      application: 'contact',
      id: '26903',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 6',
        phone: '555-test',
        userKey: '6146506820683186259',
      },
    },
    {
      application: 'contact',
      id: '30005',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 7',
        phone: '555-test',
        userKey: '6300506601969632429',
      },
    },
    {
      application: 'contact',
      id: '75440',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 8',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '45425',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 9',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '98538',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 10',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '23959',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 1',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '56240',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 2',
        phone: '555-test',
        userKey: '3838948547100956682',
      },
    },
    {
      application: 'contact',
      id: '67588',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 3',
        phone: '555-test',
        userKey: '4547668473900510970',
      },
    },
    {
      application: 'contact',
      id: '19236',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 4',
        phone: '555-test',
        userKey: '158619268522209074',
      },
    },
    {
      application: 'contact',
      id: '80061',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 5',
        phone: '555-test',
        userKey: '602681216181426860',
      },
    },
    {
      application: 'contact',
      id: '94842',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 6',
        phone: '555-test',
        userKey: '6146506820683186259',
      },
    },
    {
      application: 'contact',
      id: '89269',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 7',
        phone: '555-test',
        userKey: '6300506601969632429',
      },
    },
    {
      application: 'contact',
      id: '30094',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 8',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '57706',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 9',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '14830',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 10',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '85716',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 1',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '76369',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 2',
        phone: '555-test',
        userKey: '3838948547100956682',
      },
    },
    {
      application: 'contact',
      id: '28488',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 3',
        phone: '555-test',
        userKey: '4547668473900510970',
      },
    },
    {
      application: 'contact',
      id: '52915',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 4',
        phone: '555-test',
        userKey: '158619268522209074',
      },
    },
    {
      application: 'contact',
      id: '60996',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 5',
        phone: '555-test',
        userKey: '602681216181426860',
      },
    },
    {
      application: 'contact',
      id: '97113',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 6',
        phone: '555-test',
        userKey: '6146506820683186259',
      },
    },
    {
      application: 'contact',
      id: '35139',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 7',
        phone: '555-test',
        userKey: '6300506601969632429',
      },
    },
    {
      application: 'contact',
      id: '88469',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 8',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '68402',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 9',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '95985',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 10',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '28346',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 1',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '96010',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 2',
        phone: '555-test',
        userKey: '3838948547100956682',
      },
    },
    {
      application: 'contact',
      id: '74486',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 3',
        phone: '555-test',
        userKey: '4547668473900510970',
      },
    },
    {
      application: 'contact',
      id: '36274',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 4',
        phone: '555-test',
        userKey: '158619268522209074',
      },
    },
    {
      application: 'contact',
      id: '36294',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 5',
        phone: '555-test',
        userKey: '602681216181426860',
      },
    },
    {
      application: 'contact',
      id: '72250',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 6',
        phone: '555-test',
        userKey: '6146506820683186259',
      },
    },
    {
      application: 'contact',
      id: '28609',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 7',
        phone: '555-test',
        userKey: '6300506601969632429',
      },
    },
    {
      application: 'contact',
      id: '20864',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 8',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '33995',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 9',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'contact',
      id: '61264',
      score: 1,
      data: {
        email: 'test@goto.com',
        firstName: 'New',
        keywords: '@paging',
        lastName: 'Test 10',
        phone: '555-test',
        userKey: '7205586075161961226',
      },
    },
    {
      application: 'voicemail',
      id: '820101',
      score: 70.44161,
      data: {
        application: 'CCTRL_VOICEMAIL',
        callerchan: 'SIP/43D5cOMdVy7QtWBBdEySaK8z9aON07-000011b9',
        callerid: '&quot;Mr Cheese&quot; &lt;0475&gt;',
        cbox_id:
          'djE6NTc0MTcxYWQtNjdiOC00OWMyLWEyNTMtZDgxZjA5MjY0N2Q2L0NDVFJMX1ZPSUNFTUFJTC85NTI5Y2JiNC1iMDAyLTRiZmItOGI5MS1kNzFiMDBkOGZjMzYvZjQyNjFhYjUtMzU5YS00ZmE2LWFhMzUtMDg2ZGIwMGQzNGU4',
        context: 'outgoing',
        datacenter: 'pvu-1a',
        duration: '110',
        exten: '00475',
        folder: 'INBOX',
        folder_timestamp: 1622659308554,
        msg_id: '1622659196-00000005',
        origdate: 'Wed Jun  2 06:39:56 PM UTC 2021',
        origmailbox: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        origtime: '1622659196',
        owner_id: '574171ad-67b8-49c2-a253-d81f092647d6',
        owner_type: 'ORGANIZATION',
        priority: '3',
        rdnis: 'unknown',
        subowner_id: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        subowner_type: 'MAILBOX_ID',
        voicemail_id: 820101,
      },
    },
    {
      application: 'voicemail',
      id: '820104',
      score: 70.44161,
      data: {
        application: 'CCTRL_VOICEMAIL',
        callerchan: 'SIP/43D5cOMdVy7QtWBBdEySaK8z9aON07-000011d3',
        callerid: '&quot;Mrs Burger&quot; &lt;0475&gt;',
        cbox_id:
          'djE6NTc0MTcxYWQtNjdiOC00OWMyLWEyNTMtZDgxZjA5MjY0N2Q2L0NDVFJMX1ZPSUNFTUFJTC85NTI5Y2JiNC1iMDAyLTRiZmItOGI5MS1kNzFiMDBkOGZjMzYvMGU3OTM4NDUtY2JhNi00MDFhLWI5ZWMtMDc2MDFmNGZiNWIy',
        context: 'outgoing',
        datacenter: 'pvu-1a',
        duration: '68',
        exten: '00475',
        folder: 'INBOX',
        folder_timestamp: 1622660340745,
        msg_id: '1622660268-00000007',
        origdate: 'Wed Jun  2 06:57:48 PM UTC 2021',
        origmailbox: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        origtime: '1622660268',
        owner_id: '574171ad-67b8-49c2-a253-d81f092647d6',
        owner_type: 'ORGANIZATION',
        priority: '3',
        rdnis: 'unknown',
        subowner_id: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        subowner_type: 'MAILBOX_ID',
        voicemail_id: 820104,
      },
    },
    {
      application: 'voicemail',
      id: '820103',
      score: 70.44161,
      data: {
        application: 'CCTRL_VOICEMAIL',
        callerchan: 'SIP/43D5cOMdVy7QtWBBdEySaK8z9aON07-000011c3',
        callerid: '&quot;Mr Bacon&quot; &lt;0475&gt;',
        cbox_id:
          'djE6NTc0MTcxYWQtNjdiOC00OWMyLWEyNTMtZDgxZjA5MjY0N2Q2L0NDVFJMX1ZPSUNFTUFJTC85NTI5Y2JiNC1iMDAyLTRiZmItOGI5MS1kNzFiMDBkOGZjMzYvZjczNzY4ZGUtZDRjZS00MjZlLWIwYzctMTE1YmJkNjRjM2U1',
        context: 'outgoing',
        datacenter: 'pvu-1a',
        duration: '46',
        exten: '00475',
        folder: 'INBOX',
        folder_timestamp: 1622659629575,
        msg_id: '1622659577-00000006',
        origdate: 'Wed Jun  2 06:46:17 PM UTC 2021',
        origmailbox: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        origtime: '1622659577',
        owner_id: '574171ad-67b8-49c2-a253-d81f092647d6',
        owner_type: 'ORGANIZATION',
        priority: '3',
        rdnis: 'unknown',
        subowner_id: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        subowner_type: 'MAILBOX_ID',
        voicemail_id: 820103,
      },
    },
    {
      application: 'voicemail',
      id: '820104',
      score: 70.44161,
      data: {
        application: 'CCTRL_VOICEMAIL',
        callerchan: 'SIP/43D5cOMdVy7QtWBBdEySaK8z9aON07-000011d3',
        callerid: '&quot;Mrs Broccoli&quot; &lt;0475&gt;',
        cbox_id:
          'djE6NTc0MTcxYWQtNjdiOC00OWMyLWEyNTMtZDgxZjA5MjY0N2Q2L0NDVFJMX1ZPSUNFTUFJTC85NTI5Y2JiNC1iMDAyLTRiZmItOGI5MS1kNzFiMDBkOGZjMzYvMGU3OTM4NDUtY2JhNi00MDFhLWI5ZWMtMDc2MDFmNGZiNWIy',
        context: 'outgoing',
        datacenter: 'pvu-1a',
        duration: '68',
        exten: '00475',
        folder: 'INBOX',
        folder_timestamp: 1622660340745,
        msg_id: '1622660268-00000007',
        origdate: 'Wed Jun  2 06:57:48 PM UTC 2021',
        origmailbox: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        origtime: '1622660268',
        owner_id: '574171ad-67b8-49c2-a253-d81f092647d6',
        owner_type: 'ORGANIZATION',
        priority: '3',
        rdnis: 'unknown',
        subowner_id: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        subowner_type: 'MAILBOX_ID',
        voicemail_id: 820104,
      },
    },
    {
      application: 'voicemail',
      id: '820103',
      score: 70.44161,
      data: {
        application: 'CCTRL_VOICEMAIL',
        callerchan: 'SIP/43D5cOMdVy7QtWBBdEySaK8z9aON07-000011c3',
        callerid: '&quot;Mr Goat&quot; &lt;0475&gt;',
        cbox_id:
          'djE6NTc0MTcxYWQtNjdiOC00OWMyLWEyNTMtZDgxZjA5MjY0N2Q2L0NDVFJMX1ZPSUNFTUFJTC85NTI5Y2JiNC1iMDAyLTRiZmItOGI5MS1kNzFiMDBkOGZjMzYvZjczNzY4ZGUtZDRjZS00MjZlLWIwYzctMTE1YmJkNjRjM2U1',
        context: 'outgoing',
        datacenter: 'pvu-1a',
        duration: '46',
        exten: '00475',
        folder: 'INBOX',
        folder_timestamp: 1622659629575,
        msg_id: '1622659577-00000006',
        origdate: 'Wed Jun  2 06:46:17 PM UTC 2021',
        origmailbox: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        origtime: '1622659577',
        owner_id: '574171ad-67b8-49c2-a253-d81f092647d6',
        owner_type: 'ORGANIZATION',
        priority: '3',
        rdnis: 'unknown',
        subowner_id: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        subowner_type: 'MAILBOX_ID',
        voicemail_id: 820103,
      },
    },
    {
      application: 'voicemail',
      id: '820103',
      score: 70.44161,
      data: {
        application: 'CCTRL_VOICEMAIL',
        callerchan: 'SIP/43D5cOMdVy7QtWBBdEySaK8z9aON07-000011c3',
        callerid: '&quot;Mrs Goat&quot; &lt;0475&gt;',
        cbox_id:
          'djE6NTc0MTcxYWQtNjdiOC00OWMyLWEyNTMtZDgxZjA5MjY0N2Q2L0NDVFJMX1ZPSUNFTUFJTC85NTI5Y2JiNC1iMDAyLTRiZmItOGI5MS1kNzFiMDBkOGZjMzYvZjczNzY4ZGUtZDRjZS00MjZlLWIwYzctMTE1YmJkNjRjM2U1',
        context: 'outgoing',
        datacenter: 'pvu-1a',
        duration: '46',
        exten: '00475',
        folder: 'INBOX',
        folder_timestamp: 1622659629575,
        msg_id: '1622659577-00000006',
        origdate: 'Wed Jun  2 06:46:17 PM UTC 2021',
        origmailbox: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        origtime: '1622659577',
        owner_id: '574171ad-67b8-49c2-a253-d81f092647d6',
        owner_type: 'ORGANIZATION',
        priority: '3',
        rdnis: 'unknown',
        subowner_id: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        subowner_type: 'MAILBOX_ID',
        voicemail_id: 820103,
      },
    },
    {
      application: 'voicemail',
      id: '820103',
      score: 70.44161,
      data: {
        application: 'CCTRL_VOICEMAIL',
        callerchan: 'SIP/43D5cOMdVy7QtWBBdEySaK8z9aON07-000011c3',
        callerid: '&quot;Mr Cheese Burger&quot; &lt;0475&gt;',
        cbox_id:
          'djE6NTc0MTcxYWQtNjdiOC00OWMyLWEyNTMtZDgxZjA5MjY0N2Q2L0NDVFJMX1ZPSUNFTUFJTC85NTI5Y2JiNC1iMDAyLTRiZmItOGI5MS1kNzFiMDBkOGZjMzYvZjczNzY4ZGUtZDRjZS00MjZlLWIwYzctMTE1YmJkNjRjM2U1',
        context: 'outgoing',
        datacenter: 'pvu-1a',
        duration: '46',
        exten: '00475',
        folder: 'INBOX',
        folder_timestamp: 1622659629575,
        msg_id: '1622659577-00000006',
        origdate: 'Wed Jun  2 06:46:17 PM UTC 2021',
        origmailbox: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        origtime: '1622659577',
        owner_id: '574171ad-67b8-49c2-a253-d81f092647d6',
        owner_type: 'ORGANIZATION',
        priority: '3',
        rdnis: 'unknown',
        subowner_id: '9529cbb4-b002-4bfb-8b91-d71b00d8fc36',
        subowner_type: 'MAILBOX_ID',
        voicemail_id: 820103,
      },
    },
  ],
} as GlobalSearchResponse
